import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login, NewUser, ChangePassword } from './components';
import { Sites, Dashboard, AdminDashboard, EQADashboard, BomgarUsers } from './pages';
import { AuthProvider, useAuthContext } from './contexts/AuthContext';

const PrivateRoute = ({ element }) => {
  const { authenticated } = useAuthContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if authenticated, set loading to false once done
    if (authenticated !== undefined) {
      setLoading(false);
    }
  }, [authenticated]);

  // Render loading state until authentication status is determined
  if (loading) {
    return <div>Loading...</div>;
  }

  return authenticated ? element : <Navigate to="/login" />;
};

const App = () => {
  return (
    <AuthProvider>
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/admin-dashboard" element={<PrivateRoute element={<AdminDashboard />} />} />
            <Route path="/eqa-dashboard" element={<PrivateRoute element={<EQADashboard />} />} />
            <Route path="/bomgar" element={<PrivateRoute element={<BomgarUsers />} />} />
            <Route path="/sites" element={<PrivateRoute element={<Sites />} />} />
            <Route path="/newuser" element={<PrivateRoute element={<NewUser />} />} />
            <Route path="/changepassword" element={<PrivateRoute element={<ChangePassword />} />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
};

export default App;
